import React from 'react'
import MapsContainer from '../containers/Maps'
import changes from "../redux/changesDuck"
import {useDispatch} from "react-redux";


function MapsRoute(){
        const dispatch = useDispatch();
                dispatch(changes.actions.fetchChangesLayersRequest())

    return (
        <MapsContainer/>
        )
}

export default MapsRoute



// WEBPACK FOOTER //
// ./src/routes/Maps.js